/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=3ad6c752"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=3ad6c752&lang=css"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/1bf991ab-cd6c-4dc0-b58b-c0004fbfb0b5/workspace/zhongtaisdklistandotherh5_online/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__